import { createFeatureSelector, createSelector } from '@ngrx/store';
import { checkboxFeatureKey, CheckboxState } from './checkbox-reducer';

export const getCheckboxState =
  createFeatureSelector<CheckboxState>(checkboxFeatureKey);

export const getCheckboxStateSelector = createSelector(
  getCheckboxState,
  (state: CheckboxState) => state
);
